
import {Component, Ref, Vue} from 'vue-property-decorator'
import AjandaInfo from "@/components/infos/AjandaInfo.vue";
import IsList from "@/components/lists/IsList.vue";
import IsSablonList from "@/components/lists/IsSablonList.vue";
import {
  AJANDA_YOLU,
  AjandaTakipBaglami,
  ajandaBaglamiCoz,
  takipKartiYolu,
} from "@/helpers/AjandaGecisHelper";

@Component({
  components: {IsSablonList, IsList, AjandaInfo}
})
export default class AjandaView extends Vue {
  @Ref('isList') readonly isList!: IsList;
  @Ref('ajanda') readonly ajanda!: AjandaInfo;

  // DEV-1511: Bağlam yalnızca URL'de tutulur; sayfa yenilense de, link
  // paylaşılsa da aynı takip bağlamı geri gelir.
  get takipBaglami(): AjandaTakipBaglami | null {
    return ajandaBaglamiCoz(this.$route.query);
  }

  takipKartinaDon() {
    const yol = takipKartiYolu(this.takipBaglami?.takipId);
    if (yol) {
      this.$router.push(yol);
    }
  }

  // Ajandada kalıp bağlamı bırakmak isteyenler için: filtreyi kaldırır,
  // geçmişi kirletmemek adına replace kullanılır.
  baglamiTemizle() {
    this.$router.replace({path: AJANDA_YOLU});
  }

  loadSablonPicker() {
    if (this.isList) {
      this.isList.loadSablon();
    }
  }

  loadAjanda() {
    if (this.ajanda) {
      this.ajanda.load();
    }
  }

  sablonYuklendi(sablonlar: any[]) {
    this.$nextTick(() => {
      this.loadAjanda();
    });
  }
}
